import Service from 'src/setup/network';
import { loginConstant } from '../constant';
import { toastAlert } from 'src/utils/toastAlert';

export const loginAction = (val: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: loginConstant.LOGIN,
    });
    try {
      const { data } = await Service.post('/employees/login', val);
      const userInfo = {
        businessInfo: data?.data?.businessInfo ?? '',
        userInfo: data?.data?.employeeInfo ?? '',
        accessToken: data?.data?.access_token ?? '',
        role: data?.data?.employeeInfo?.role ?? '',
      };

      window.localStorage.setItem(
        'accessToken',
        JSON.stringify(data?.data?.access_token ?? '')
      );
      dispatch({
        type: loginConstant.LOGIN_SUCCESS,
        payload: userInfo,
      });
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo));
      window.localStorage.setItem('role', JSON.stringify(userInfo.role));
    } catch (err: any) {
      dispatch({
        type: loginConstant.LOGIN_FAILURE,
        payload: err?.response?.data?.message ?? 'Something went wrong.',
      });
    }
  };
};

export const isUserLoggedIn = () => {
  return async (dispatch: any) => {
    const expiresAt = window.localStorage.getItem('expiresAt');
    let accessToken;
    const tokens = ['accessToken', 'userInfo', 'role', 'expiresAt'];
    const role = JSON.parse(window.localStorage.getItem('role') || '');

    if (expiresAt && new Date().getTime() < parseInt(expiresAt)) {
      accessToken = window.localStorage.getItem('accessToken');
      if (accessToken) {
        dispatch({
          type: loginConstant.LOGIN_SUCCESS,
          payload: [accessToken, role],
        });
      }
    } else {
      toastAlert('error', 'Session has Expired. Please Relogin');
      dispatch({
        type: 'LOGOUT',
        payload: 'Logout Successful',
      });
      setTimeout(() => {
        window.localStorage.clear();
      }, 500);
    }
  };
};
export const logoutAction = (): any => {
  window.localStorage.clear();
  return async (dispatch: any) => {
    dispatch({
      type: 'LOGOUT',
      payload: 'Logout Successful',
    });
  };
};
